// extracted by mini-css-extract-plugin
export default {"container":"SashLayer_container__Tf-d2","containerSmall":"SashLayer_containerSmall__LQnKJ","text":"SashLayer_text__bjTE3","textSmall":"SashLayer_textSmall__rQk3n"};